import { StyleSheet } from 'aphrodite';

export default StyleSheet.create({
  container: {
    display: 'flex',
    flexDirection: 'row',
    height: '100%',
  },
  left: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'flex-start',
    paddingBottom: 80,
  },
  rigth: {
    flex: 1,
    flexDirection: 'row',
    height: '100%',
    backgroundColor: '#F6F8F9',
    paddingBottom: 80,
  },
  result: {
    display: 'flex',
    height: '100%',
    marginTop: 40,
    marginRight: 40,
    paddingBottom: 80,
  },
  analysis: {
    position: 'relative',
    boxSizing: 'border-box',
    height: '100%',
    marginTop: 40,
    marginLeft: 40,
  },
  answerBox: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: 20,
    paddingLeft: 10,
    paddingRight: 10,
    height: 40,
    lineHeight: '40px',
  },

  rigthAnswer: {
    backgroundColor: '#F0FFF1',
  },

  wrongAnswer: {
    backgroundColor: '#FFF0F0',
  },

  answerResult: {
    justifyContent: 'space-around',
    color: '#878F98',
    background: 'rgba(246,248,249,1)',
    height: 70,
    lineHeight: '20px',
    paddingLeft: 10,
  },

  myAnswer: {
    marginLeft: 10,
    lineHeight: '20px',
  },

  colorFD5454: {
    color: '#FD5454',
  },

  color49cf51: {
    color: '#49cf51',
  },

  answerDefault: {
    marginLeft: 10,
    color: '#32363a',
    lineHeight: '20px',
    fontFamily: 'PingFangSC-Semibold',
  },

  icon: {
    width: 4,
    height: 18,
    background: 'rgba(51,153,255,1)',
    borderRadius: '100px',
    marginRight: 5,
  },

  questionInsertDirection: {
    display: 'block',
    marginBottom: 20,
    fontSize: 16,
  },

  textRigth: {
    display: 'inline-block',
    height: '100%',
    width: 509,
    fontSize: 16,
    color: '#32363A',
    lineHeight: '22px',
    marginTop: 38,
    fontFamily: 'PingFangSC',
    paddingBottom: 120,
    overflowY: 'auto',
  },

  questionInsertDirectionBlock: {
    display: 'inline-block',
    width: 14,
    height: 14,
    marginLeft: 5,
    marginRight: 5,
    fontSize: 16,
  },

  questionInsertSentence: {
    fontWeight: 'bold',
    marginBottom: 20,
    fontSize: 16,
  },

  questionInsertTip: {
    display: 'block',
    fontSize: 16,
  },

  title: {
    fontSize: 16,
    color: '#32363A',
    lineHeight: '24px',
    marginBottom: 20,
  },

  title1: {
    flexDirection: 'row',
    position: 'fixed',
  },

  text: {
    fontSize: 16,
    color: '#32363A',
    lineHeight: '24px',
    width: 510,
    height: '100%',
    marginTop: 20,
    paddingBottom: '80px',
    paddingRight: 5,
    overflowY: 'auto',
  },

  div: {
    fontSize: 16,
    color: '#32363A',
    lineHeight: '24px',
    width: 510,
    marginTop: 20,
  },

  title2: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 18,
  },

  line: {
    width: 175,
    height: 1,
    background: 'rgba(50,54,58,1)',
    marginTop: 10,
  },

  buttons: {
    flexDirection: 'row',
    color: '#878F98',
  },

  buttonText: {
    color: '#878F98',
    fontSize: 12,
  },

  button: {
    width: 80,
    backgroundColor: '#fff',
    color: '#878F98',
    border: '1px solid #878F98',
    ':hover': {
      backgroundColor: '#000000',
      color: '#fff',
    },
  },

  buttonActive: {
    backgroundColor: '#000000',
    color: '#fff',
  },

  count: {
    width: 86,
    height: 17,
    fontSize: '12px',
    fontFamily: 'PingFangSC',
    color: 'rgba(50,54,58,1)',
    lineHeight: '17px',
  },
  answerAnalysis: {
    fontSize: 14,
    lineHeight: '20px',
  },
  text1: {
    fontSize: 16,
    color: '#32363A',
    lineHeight: '24px',
    marginBottom: 20,
    justifyContent: 'center',
    alignItems: 'center',
  },
  textContent: {
    fontSize: 16,
    color: '#32363A',
    lineHeight: '24px',
    marginBottom: 31,
  },
  image: {
    width: '100px',
    height: '100px',
    margin: '20px auto 10px auto',
  },
});



// WEBPACK FOOTER //
// ./src/components/report/base_report/speaking_report/styles.js